import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import axios from 'axios';
import { useHistory, useLocation, useParams } from 'react-router';
import { ItemResponse, SaveResponse } from 'helpers/interfaces';


interface IContext {
    isSaving: boolean

    isLoading: boolean,
    ticketPriority: ticketPriority
    saveticketPriority: (ticket: ticketPriority) => Promise<void>
}

export let ticketPrioritySchema = yup.object().shape({
    id: yup.string().default(''),
    description: yup.string().default('').required(),
    color: yup.string().default('#000000'),
    sortOrder: yup.string().default('0')
});

type ticketPriority = yup.InferType<typeof ticketPrioritySchema>;

export let ticketPriorityContext = React.createContext({} as IContext);

let { Provider } = ticketPriorityContext;

let TicketPriorityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let history = useHistory();

    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    
    let isNew = location.pathname.includes("/addnew");

    let [isSaving, setSaving] = useState(false);
    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [ticketPriority,setticketPriority] = useState(ticketPrioritySchema.getDefault())



    useEffect(() => {
        if (isNew === false)
            getticketPriority();

    }, [id, isNew])

    let getticketPriority = async () => {
        try {
            let res = await axios.get<ItemResponse<ticketPriority>>('/api/ticketPriority/GetticketPriority', { params: { id } });

            let { item } = res.data;
            setticketPriority(item);
            setLoading(false);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    
    let saveticketPriority = async (ticketPriority: ticketPriority) => {
        try {
            setSaving(true);
            let res = await axios.post<SaveResponse>('/api/ticketPriority/SaveticketPriority', ticketPriority);
            history.goBack();
        } catch (err) {
            setSaving(false);
        }
    }
    
    return (
        <Provider
            value={{
                isSaving,
                saveticketPriority,
                ticketPriority,
                isLoading
            }}
        >
            {children}
        </Provider>
    )
}

export default TicketPriorityProvider;